export default "__VITE_PUBLIC_ASSET__7d3eb707__"